import { axiosInstance } from '@/modules/shared/lib/axios'

type Props = {
  companyId: string
  driverId: number
}

export function refreshDriverViolations({ companyId, driverId }: Props) {
  return axiosInstance.post<boolean>(`/api/${companyId}/violation/refresh`, { driverId })
}
